module.exports = __webpack_public_path__ + "media/images/post_event/post_event_logo-b4e5cb4408bbf4dd64df8971502ef5f6.png";